import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, MapPin, Sparkles } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";

const COPY = {
  nl: {
    badge: "Uitgelicht project",
    title: "Listone Residence",
    sub: "Betaalbare luxe in Al Warsan — volledig gemeubileerd, smart home, op 850 m van de metro. Vanaf AED 540K (± €132K).",
    loc: "Al Warsan, Dubai · Oplevering Q2 2028",
    cta: "Ontdek Listone Residence",
    tag: "Nieuwe launch",
  },
  en: {
    badge: "Featured project",
    title: "Listone Residence",
    sub: "Affordable luxury in Al Warsan — fully furnished, smart home, 850m from the metro. From AED 540K.",
    loc: "Al Warsan, Dubai · Handover Q2 2028",
    cta: "Explore Listone Residence",
    tag: "New launch",
  },
};

export const FeaturedListone = () => {
  const { lang } = useI18n();
  const t = COPY[lang] || COPY.en;
  return (
    <section className="py-8 sm:py-14" data-testid="home-featured-listone">
      <div className="container-x">
        <Link to="/listone" data-testid="featured-listone-link" className="group block">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="relative grid overflow-hidden rounded-[2rem] bg-navy shadow-2xl lg:grid-cols-2">
            {/* image */}
            <div className="relative min-h-[280px] overflow-hidden lg:min-h-[440px]">
              <img src="/listone/img/exterior-sunset.jpg" alt="Listone Residence"
                className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-navy/10 to-transparent lg:bg-gradient-to-r" />
              <span className="absolute left-5 top-5 inline-flex items-center gap-1.5 rounded-full bg-gold px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-white">
                <Sparkles size={13} /> {t.tag}
              </span>
            </div>
            {/* content */}
            <div className="relative flex flex-col justify-center p-8 text-white sm:p-12">
              <span className="inline-flex w-fit items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.2em] text-gold">
                {t.badge}
              </span>
              <h2 className="mt-5 font-display text-4xl font-semibold tracking-tight sm:text-5xl">
                Listone <span className="text-gold-300">Residence</span>
              </h2>
              <p className="mt-2 flex items-center gap-2 text-sm text-white/60">
                <MapPin size={15} className="text-gold-300" /> {t.loc}
              </p>
              <p className="mt-4 max-w-md text-base leading-relaxed text-white/80">{t.sub}</p>
              <span className="mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-gold px-7 py-3.5 text-sm font-medium text-white transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:shadow-gold">
                {t.cta}
                <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </div>
          </motion.div>
        </Link>
      </div>
    </section>
  );
};
